import { render } from "./UserLabelListItem.vue?vue&type=template&id=19237d09&ts=true"
import script from "./UserLabelListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLabelListItem.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/user-label/components/UserLabelListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19237d09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19237d09', __exports__)) {
    api.reload('19237d09', __exports__)
  }
  
  module.hot.accept("./UserLabelListItem.vue?vue&type=template&id=19237d09&ts=true", () => {
    api.rerender('19237d09', render)
  })

}


export default __exports__